import { AppRouteType } from 'layouts/helper';
import routesMap from 'layouts/routesMap';
import { memoize } from 'lodash';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// Nav pages: eager import — tránh Suspense blank khi navigate
import HomePage from 'pages/HomePage';
import GioiThieuPage from 'pages/GioiThieu';
import TraCuuPage from 'pages/TraCuu';
import TinTucAllPage from 'pages/TinTuc/TinTucAllPage';
import TinTucGHTMPage from 'pages/TinTuc';
import TinTucNganhPage from 'pages/TinTuc/TinTucNganhPage';
import ArticleDetailPage from 'pages/TinTuc/ArticleDetailPage';
import LienHePage from 'pages/LienHe';


// Auth pages: lazy (ít dùng, tiết kiệm bandwidth)
const LoginPage = lazy(() => import('pages/DangNhap/LoginPage'));
const SingupPage = lazy(() => import('pages/DangNhap/SignupPage'));
const ForgetpassPage = lazy(() => import('pages/DangNhap/ForgetpassPage'));
const PrintPage = lazy(() => import('pages/PrintPage'));
const TaoDonKDangNhapPage = lazy(() => import('pages/TaoDon/TaoDonKDangNhapPage'));

const HomeRedirect = () => <Navigate to={routesMap.TRANG_CHU} replace />;

const routes: AppRouteType[] = [
  {
    path: routesMap.HOME,
    component: HomeRedirect,
  },
  {
    path: routesMap.LOGIN,
    component: LoginPage,
  },
  {
    path: routesMap.SIGNUP,
    component: SingupPage,
  },
  {
    path: routesMap.FORGET_PASSWORD,
    component: ForgetpassPage,
  },
  {
    path: routesMap.TAO_DON,
    component: TaoDonKDangNhapPage,
  },
  {
    path: routesMap.PRINT,
    component: PrintPage,
  },
  {
    path: routesMap.TRANG_CHU,
    component: HomePage,
  },
  {
    path: routesMap.GIOI_THIEU,
    component: GioiThieuPage,
  },
  {
    path: routesMap.TIN_TUC,
    component: TinTucAllPage,
  },
  {
    path: routesMap.TIN_TUC_GHTM,
    component: TinTucGHTMPage,
  },
  {
    path: routesMap.TIN_TUC_NGANH,
    component: TinTucNganhPage,
  },
  {
    path: routesMap.TIN_TUC_SLUG,
    component: ArticleDetailPage,
  },
  {
    path: routesMap.TRA_CUU,
    component: TraCuuPage,
  },
  {
    path: routesMap.LIEN_HE,
    component: LienHePage,
  },
];

const getRoutePublic = memoize(() => {
  return routes;
});

export default getRoutePublic;
